// extracted by mini-css-extract-plugin
module.exports = {"aboutUsContainer":"about-us_aboutUsContainer__Qmq5R","landingSectionTitle":"about-us_landingSectionTitle__teQPR"};